import React from 'react';
import vidd from "../Assets/images/Critical thinking (2).gif";
import "../Assets/styles/creative.css";

const Creative = () => {
  return (
    <>
      <div className="container-lg creative-cont">
        <div className="row">
          <div className="col-lg-6">
            <div className="creative-content">
              <h3 data-aos="fade-up" data-aos-duration="1000ms">How To Generate <span>Creative</span> Ideas</h3>
              {/* <div className="bar"></div> */}
              <p>Everyone encounters problems daily. By observing and empathizing, we can spot them and make positive changes.</p>
              <div id="accordion">
              <div className="card trey" data-aos="fade-up" data-aos-duration="1000ms">
              <div className="btn card-header ngga" data-bs-toggle="collapse" href="#collapseOne">
              Stay Observant
              </div>
              <div id="collapseOne" className="collapse show" data-bs-parent="#accordion">
                  <div className="card-body">             
                    <div className="dejav"><p>
                    Pay attention to your environment, including your workplace and the tools you use daily. Problems often arise from inefficiencies, inconsistencies, or gaps in systems and processes. If a tool or process is useful for one company, it's likely applicable to many more, suggesting broader relevance.                  
                  </p> </div>            
                  </div>
              </div>
              </div>
              <div className="card trey" data-aos="fade-up" data-aos-duration="1000ms">
              <div className="card-header ngga collapsed btn" data-bs-toggle="collapse" href="#collapseTwo">
              Listen to People's Concerns
              </div>
              <div id="collapseTwo" className="collapse" data-bs-parent="#accordion">
                <div className="card-body">
                  <div className="dejav">
                  By observing feedback, reviews, or customer complaints regarding products, services, or processes, one can identify recurring issues or pain points. These complaints often highlight areas where improvements or innovative solutions are needed. Therefore, listening to people's concerns about existing solutions can provide valuable insights into potential problems worth addressing.
                  </div>
                </div>
              </div>
              </div>
              <div className="card trey" data-aos="fade-up" data-aos-duration="1000ms">
              <div className="card-header ngga collapsed btn" data-bs-toggle="collapse" href="#collapseThree">
              Identify Inefficiencies
              </div>
              <div id="collapseThree" className="collapse" data-bs-parent="#accordion">
                <div className="card-body">
                  <div className="dejav">
                  Entails recognizing areas where processes or systems could be improved or streamlined. These inefficiencies might manifest as repetitive tasks, unnecessary delays, or cumbersome workflows. By identifying such inefficiencies, individuals can pinpoint areas ripe for optimization and innovation, ultimately enhancing productivity and effectiveness.
                  </div>
                </div>
              </div>
              </div>
              <div className="card trey" data-aos="fade-up" data-aos-duration="1000ms">
              <div className="card-header ngga collapsed btn" data-bs-toggle="collapse" href="#collapseFour">
              There should be an easier way
              </div>
              <div id="collapseFour" className="collapse" data-bs-parent="#accordion">
                <div className="card-body">
                  <div className="dejav">
                  That computational task does not have to be done like that, this task can be done like this, and so many more. 
                  <br />
                  By identifying these situations properly, we can explore opportunities to innovate and create solutions that address these gaps, ultimately enhancing people's lives and experiences.
                  </div>
                </div>
              </div>
              </div>
              <div className="card trey" >
              <div className="card-header ngga collapsed btn" data-bs-toggle="collapse" href="#collapseFive">
              It can be you!
              </div>
              <div id="collapseFive" className="collapse" data-bs-parent="#accordion">
                <div className="card-body">
                  <div className="dejav">
                    Be open to serendipity and unexpected opportunities. <br />
                    Don't underestimate your ability to tackle big challenges. <br />
                    Have faith in your capacity to make a difference, one problem at a time. <br />
                    Remember, even the smallest idea can lead to significant solutions.
                  </div>
                </div>
              </div>
              </div>
            </div>
            </div>
          </div>
          <div className="col-lg-6 creative-right" data-aos="fade-up" data-aos-duration="1000ms">
            <img src={vidd} alt="vdf" className='vidd' />
          </div>
        </div>
      </div>
    </>
  );
}

// const SkillItem = ({ title, percent }) => (
//   <div className="skills">
//     <div className="skill-item">
//       <div className="skill-header d-flex justify-content-between" style={{marginTop: '5px'}}>
//         <h4 className='skill-title'>{title}</h4>
//         <p>{percent}%</p>
//       </div>
//       <div className="skill-bar">
//         <ProgressBar now={percent} style={{height: '5px'}}/>
//       </div>
//     </div>
//   </div>
// );

export default Creative;
